module.exports = __webpack_public_path__ + "static/img/theme_dark.94759df7.png";